// extracted by mini-css-extract-plugin
module.exports = {"box":"contact-module--box--rS_cK"};